import React, { Component } from 'react'

export class Feedback extends Component {
  render() {
    return (
      <div>
        <h1>Give us Feedback</h1>
      </div>
    )
  }
}

export default Feedback
